<template>
    <b-navbar
        type="light"
        class="navbar-light theme-nav fixed-top"
        toggleable="lg"
        fixed="top"
        v-b-scrollspy:nav-scroller
    >
        <div class="container">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand" :to="{name:'home'}">
                <AnimatedLogo/>
            </b-navbar-brand>
            <b-collapse class="default-nav" is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
                    <b-nav-item href="#home">Home</b-nav-item>
                    <b-nav-item href="#feature">Our Games</b-nav-item>
                    <b-nav-item href="#about">Hire Us</b-nav-item>
                    <b-nav-item href="#screenshot">Skills</b-nav-item>

                    <b-nav-item-dropdown right-alignment text="walkthroughs" class="nav-link">
                        <b-dropdown-item
                            class="nav-link"
                            :to="{name:'office'}"
                            :href="'/office'"
                        >The Office</b-dropdown-item>
                        <b-dropdown-item class="nav-link" :to="{name:'car'}" :href="'/car'">The Car</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            :to="{name:'jailcell'}"
                            :href="'/jailcell'"
                        >The Jail Cell</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            :to="{name:'garage'}"
                            :href="'/garage'"
                        >The Garage</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item-dropdown right-alignment text="leaderboards" class="nav-link">
                        <!--    <b-dropdown-item class="nav-link"  :to="{name:'blog_list'}" >Escape the Room</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_details'}"> Escape the Airplane</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  :to="{name:'Blog_leftside'}"> Christmas Escape</b-dropdown-item>-->
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/puzzleoftheday/"
                        >Puzzle of the Day</b-dropdown-item>

                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/gameofwords/"
                        >Game of Words</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/wordplay/leaderboard.html"
                        >Word Play</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/wordwiz/"
                        >Word Wiz</b-dropdown-item>
                        <b-dropdown-item
                            class="nav-link"
                            href="https://www.stokedskills.com/angelinvestor/"
                        >Angel Investor</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <!-- <b-nav-item href="#price">price</b-nav-item> -->
                    <!--   <b-nav-item href="#contact">contact us</b-nav-item> -->
                    <!--
          <b-nav-item-dropdown right-alignment href="#Other_page" text="Other page" class="nav-link ">
            <b-dropdown-item class="nav-link"  :to="{name:'Signin'}" :href='"/tovo/sign-in"'>sign in</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Signup'}" :href='"/tovo/sign-up"' >sign up</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'ForgetPassword'}" :href='"/tovo/forget-Password"' >Forget Password</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Thankyou'}" :href='"/tovo/thank-you"' >Thank you</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Review'}" :href='"/tovo/review"' >Review</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'pagenotfound'}" :href='"/tovo/404"' >404</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Faq'}" :href='"/tovo/faq"' >FAQ</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'download'}" :href='"/tovo/download"' >Download</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'coming_soon'}" :href='"/tovo/coming-soon"' >coming soon</b-dropdown-item>
          </b-nav-item-dropdown>
                    -->
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>
<script>
export default {
    name: "Navbar"
};
</script>



// WEBPACK FOOTER //
// src/components/navbar.vue